/* eslint-disable no-param-reassign */
import produce from 'immer';
import {
  SET_GROUP_TYPE_DETAILS_TAB,
  SET_IS_MODAL_VISIBLE,
  SET_IS_MODAL_LOADING,
  SET_MODAL_MESSAGE,
  GET_GROUP_TYPE,
  GET_GROUP_TYPE_SUCCESS,
  GET_GROUP_TYPE_ERROR,
  CLEAR_GROUP_TYPE_DETAILS,
  CREATE_GROUP_TYPE,
  CREATE_GROUP_TYPE_SUCCESS,
  CREATE_GROUP_TYPE_ERROR,
  UPDATE_GROUP_TYPE,
  UPDATE_GROUP_TYPE_SUCCESS,
  UPDATE_GROUP_TYPE_ERROR,
  DELETE_GROUP_TYPE,
  DELETE_GROUP_TYPE_SUCCESS,
  DELETE_GROUP_TYPE_ERROR,
  CLEAR_GROUP_TYPE_WAS_DELETED,
  SET_FORM_CREATE_UPDATE_GROUP_TYPE,
  GET_ACTION_GROUP_TYPES,
  GET_ACTION_GROUP_TYPES_SUCCESS,
  GET_ACTION_GROUP_TYPES_ERROR,
  SET_UPDATE_GROUP_JOIN_ACTIONS,
  GET_FOLLOW_UP_MESSAGES,
  GET_FOLLOW_UP_MESSAGES_SUCCESS,
  GET_FOLLOW_UP_MESSAGES_ERROR,
  REPLACE_SYSTEM_GEN_MESSAGE,
  REPLACE_SYSTEM_GEN_MESSAGE_SUCCESS,
  REPLACE_SYSTEM_GEN_MESSAGE_ERROR,
  SET_FORM_UPDATE_GROUP_TYPE_CONTACT_MESSAGING,
  SET_VALUES_WELCOME_MESSAGE,
  UPDATE_GROUP_TYPE_CONTACT_MESSAGING,
  UPDATE_GROUP_TYPE_CONTACT_MESSAGING_SUCCESS,
  UPDATE_GROUP_TYPE_CONTACT_MESSAGING_ERROR,
  SET_CURRENT_SMART_ACTION_TYPE,
  GET_CUSTOM_FIELDS,
  GET_CUSTOM_FIELDS_SUCCESS,
  GET_CUSTOM_FIELDS_ERROR,
} from 'src/actions/groupTypeDetailsActions';

const modalMessage = {
  isVisible: false,
  modalTitle: null,
  modalBody: '',
};

const welcomeMessage = {
  systemGenMessageReplaced: false,
  attachment: false,
  attachmentContainer: null,
  loading: false,
};

const followUpMessages = {
  followUpMessageList: [],
  loading: false,
};

const actionGroupTypes = {
  actionGroupTypesList: [],
  loading: false,
};

const customFields = {
  customFieldsList: [],
  loading: false,
};

const initialState = {
  groupType: {},
  actionGroupTypes, // Smart Action Types field in the UI
  currentSmartActionType: null,
  groupTypeWasDeleted: false,
  loading: false,
  currentNavigationTab: 'details',
  modalMessage,
  formEditGroupType: {
    hasUpdatedCustomFields: false,
  },
  welcomeMessage,
  followUpMessages,
  isModalVisible: false,
  isModalLoading: false,
  updateGroupJoinActions: false,
  customFields,
};

const groupTypeDetailsReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case SET_GROUP_TYPE_DETAILS_TAB: {
      return produce(state, (draft) => {
        draft.currentNavigationTab = payload || initialState.currentNavigationTab;
      });
    }

    case SET_IS_MODAL_LOADING: {
      return produce(state, (draft) => {
        draft.isModalLoading = payload;
      });
    }

    case SET_IS_MODAL_VISIBLE: {
      return produce(state, (draft) => {
        draft.isModalVisible = !state.isModalVisible;
      });
    }

    case SET_MODAL_MESSAGE: {
      return produce(state, (draft) => {
        draft.modalMessage = {
          ...state.modalMessage,
          ...payload,
        };
      });
    }

    case GET_GROUP_TYPE:
    case CREATE_GROUP_TYPE:
    case UPDATE_GROUP_TYPE:
    case DELETE_GROUP_TYPE: {
      return produce(state, (draft) => {
        draft.loading = true;
      });
    }

    case GET_GROUP_TYPE_SUCCESS: {
      return produce(state, (draft) => {
        draft.groupType = payload?.groupType || {};
        draft.loading = false;
      });
    }

    case GET_GROUP_TYPE_ERROR:
    case CREATE_GROUP_TYPE_SUCCESS:
    case CREATE_GROUP_TYPE_ERROR:
    case UPDATE_GROUP_TYPE_SUCCESS:
    case UPDATE_GROUP_TYPE_ERROR:
    case DELETE_GROUP_TYPE_ERROR: {
      return produce(state, (draft) => {
        draft.loading = false;
      });
    }

    case CLEAR_GROUP_TYPE_DETAILS: {
      return produce(state, (draft) => {
        draft.groupType = initialState.groupType;
      });
    }

    case DELETE_GROUP_TYPE_SUCCESS: {
      return produce(state, (draft) => {
        draft.groupType = payload ? initialState.groupType : state.groupType;
        draft.loading = false;
        draft.groupTypeWasDeleted = true;
      });
    }

    case CLEAR_GROUP_TYPE_WAS_DELETED: {
      return produce(state, (draft) => {
        draft.groupTypeWasDeleted = false;
      });
    }

    case SET_FORM_CREATE_UPDATE_GROUP_TYPE: {
      return produce(state, (draft) => {
        draft.formEditGroupType = payload ? {
          ...state.formEditGroupType,
          ...payload,
        } : initialState.formEditGroupType;
      });
    }

    case GET_ACTION_GROUP_TYPES: {
      return produce(state, (draft) => {
        draft.actionGroupTypes.loading = true;
      });
    }

    case GET_ACTION_GROUP_TYPES_SUCCESS: {
      return produce(state, (draft) => {
        draft.actionGroupTypes.actionGroupTypesList = payload?.actionGroupTypes || [];
        draft.actionGroupTypes.loading = false;
      });
    }

    case GET_ACTION_GROUP_TYPES_ERROR: {
      return produce(state, (draft) => {
        draft.actionGroupTypes.loading = false;
      });
    }

    case SET_UPDATE_GROUP_JOIN_ACTIONS: {
      return produce(state, (draft) => {
        draft.updateGroupJoinActions = payload;
      });
    }

    case GET_FOLLOW_UP_MESSAGES: {
      return produce(state, (draft) => {
        draft.followUpMessages.loading = true;
      });
    }

    case GET_FOLLOW_UP_MESSAGES_SUCCESS:
    case GET_FOLLOW_UP_MESSAGES_ERROR: {
      return produce(state, (draft) => {
        draft.followUpMessages.loading = false;
        draft.followUpMessages.followUpMessageList = payload ? [
          ...state.followUpMessages.followUpMessageList,
          ...payload,
        ] : followUpMessages.followUpMessageList;
      });
    }

    case REPLACE_SYSTEM_GEN_MESSAGE: {
      return produce(state, (draft) => {
        draft.welcomeMessage.loading = true;
      });
    }

    case REPLACE_SYSTEM_GEN_MESSAGE_SUCCESS:
    case REPLACE_SYSTEM_GEN_MESSAGE_ERROR: {
      return produce(state, (draft) => {
        draft.welcomeMessage.loading = false;
        draft.welcomeMessage.systemGenMessageReplaced = payload || false;
      });
    }

    case SET_FORM_UPDATE_GROUP_TYPE_CONTACT_MESSAGING: {
      return produce(state, (draft) => {
        draft.formGroupTypeGuestMessaging = payload ? {
          ...state.formGroupTypeGuestMessaging,
          ...payload,
        } : initialState.formGroupTypeGuestMessaging;
      });
    }

    case SET_VALUES_WELCOME_MESSAGE: {
      return produce(state, (draft) => {
        draft.welcomeMessage = payload ? {
          ...state.welcomeMessage,
          ...payload,
        } : welcomeMessage;
      });
    }

    case UPDATE_GROUP_TYPE_CONTACT_MESSAGING: {
      return produce(state, (draft) => {
        draft.loading = true;
      });
    }

    case UPDATE_GROUP_TYPE_CONTACT_MESSAGING_SUCCESS:
    case UPDATE_GROUP_TYPE_CONTACT_MESSAGING_ERROR: {
      return produce(state, (draft) => {
        draft.loading = false;
      });
    }

    case SET_CURRENT_SMART_ACTION_TYPE: {
      return produce(state, (draft) => {
        draft.currentSmartActionType = payload || null;
      });
    }

    case GET_CUSTOM_FIELDS: {
      return produce(state, (draft) => {
        draft.customFields.loading = true;
      });
    }

    case GET_CUSTOM_FIELDS_SUCCESS:
    case GET_CUSTOM_FIELDS_ERROR: {
      return produce(state, (draft) => {
        draft.customFields.loading = false;
        draft.customFields.customFieldsList = payload?.data
          ? payload.data
          : initialState.customFields.customFieldsList;
      });
    }

    default: {
      return state;
    }
  }
};

export default groupTypeDetailsReducer;
